import { createFetcher } from '../contexts/Fetcher';
import { useCallback, useContext } from 'react';
import { apiCloudLive } from '../resources/api/apiCloudLive';
import { LiveRegionContext } from '../contexts/LiveRegionContext';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { pending } from '../helpers/pending';

const { useGetOrganizationStacksList, useGetOrganizationStacksListSilent } = apiCloudLive;

export const CustomerLiveFetcher = createFetcher(() => {
  const { region } = useContext(LiveRegionContext);
  const { organization } = useContext(OrganizationContext);

  const { execute } = useGetOrganizationStacksList(organization ?? void 0, region);
  const { execute: executeSilent } = useGetOrganizationStacksListSilent(organization ?? void 0, region);

  const combinedExecute = useCallback(
    ({ silent = false }: { silent?: boolean }) => {
      return silent ? executeSilent() : execute();
    },
    [execute, executeSilent]
  );

  return organization && region ? combinedExecute : pending;
});
